<template>
    <div class="not_found">
        <WebViewHeader :is-show-close-btn="true" :is-show-back-btn="false" />
        <section>
            <img src="@/assets/images/hissam/img_fail2.png" alt="아이콘">
            <h2>찾을 수 없는 페이지입니다.</h2>
            <p>요청하신 페이지가 변경, 삭제되었거나<br>잘못된 경로를 입력하셨습니다.</p>
        </section>
    </div>
</template>
<script>
export default {
    name: "NotFound",
    components: {
        WebViewHeader: () => import("../components/WebViewHeader.vue")
    },
    data() {
        return {}
    },
    methods: {}
}
</script>

<style scoped lang="scss">
.not_found {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background-color: #FFFFFF;

    section {
        padding: 0 16px;

        img {
            display: block;
            width: 72px;
            height: 72px;
            margin: 0 auto 20px;
        }

        h2 {
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 8px;
            text-align: center;
        }

        p {
            color: #555555;
            line-height: 18px;
            text-align: center;
        }
    }
}
</style>